import React from 'react'

export const EnvelopeGreetz: React.FC<
  React.HTMLAttributes<HTMLOrSVGElement>
> = props => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.879 95C72.7696 95 93.758 73.7335 93.758 47.5C93.758 21.2665 72.7696 0 46.879 0C20.9884 0 0 21.2665 0 47.5C0 73.7335 20.9884 95 46.879 95Z"
        fill="#FADAD7"
      />
      <path
        d="M8.45117 39.8257L44.4221 9.38822C45.8981 8.13931 48.0609 8.13931 49.5369 9.38822L85.5079 39.8257L46.9791 67.9807L8.45117 39.8257Z"
        fill="#FADAD7"
      />
      <path
        d="M43.625 8.05749C45.6658 6.48296 48.5452 6.53555 50.53 8.21505L86.501 38.6518C86.8605 38.9561 87.061 39.4085 87.0442 39.8793C87.0274 40.3501 86.7951 40.7875 86.4147 41.0655L47.886 69.2205C47.3461 69.6148 46.6131 69.6148 46.0732 69.2205L7.54527 41.0655C7.16489 40.7875 6.93256 40.3501 6.91577 39.8793C6.89901 39.4085 7.09944 38.9561 7.45899 38.6518L43.4299 8.21505L43.625 8.05749ZM48.5447 10.5605C47.6982 9.84435 46.482 9.79957 45.5893 10.4262L45.4152 10.5605L10.9344 39.7352L46.9796 66.076L83.0248 39.7352L48.5447 10.5605Z"
        fill="#47093A"
      />
      <g className="card" filter="url(#greetz-card-shadow)">
        <path
          d="M16.3547 27.5272C16.3547 24.6816 18.6616 22.3748 21.5072 22.3748H71.4645C74.3102 22.3748 76.617 24.6816 76.617 27.5272V70.7822H16.3547V27.5272Z"
          fill="white"
        />
      </g>
      <g className="pin">
        <path
          d="M28.5478 39.2298L28.6297 41.3182C28.6393 41.5636 28.443 41.7677 28.1974 41.7677H26.9411C26.6924 41.7677 26.4948 41.5584 26.5093 41.31L26.6319 39.205L24.7269 40.758C24.5238 40.9236 24.2212 40.8719 24.0845 40.6482L23.4822 39.6627C23.3544 39.4534 23.4258 39.1799 23.6396 39.0599L25.6865 37.9111L23.4848 37.018C23.2503 36.9229 23.1472 36.6476 23.2616 36.4218L23.8207 35.3178C23.9299 35.1022 24.1947 35.0179 24.4085 35.1307L26.7066 36.3436L26.6031 34.1091C26.5917 33.8626 26.7885 33.6565 27.0352 33.6565H28.3351C28.585 33.6565 28.7829 33.8676 28.7667 34.117L28.6224 36.3436L30.6109 34.7738C30.8118 34.6152 31.1057 34.6647 31.2435 34.8804L31.8838 35.8827C32.0178 36.0923 31.9477 36.3714 31.7307 36.493L29.6425 37.6623L31.9209 38.6448C32.154 38.7453 32.2509 39.0239 32.1304 39.2473L31.5392 40.3431C31.426 40.5529 31.1644 40.6316 30.9543 40.519L28.5478 39.2298Z"
          fill="#F5084A"
        />
        <path
          d="M41.0683 39.2298L41.1502 41.3182C41.1598 41.5636 40.9635 41.7677 40.7179 41.7677H39.4616C39.2129 41.7677 39.0154 41.5584 39.0298 41.31L39.1524 39.205L37.2474 40.758C37.0443 40.9236 36.7417 40.8719 36.605 40.6482L36.0027 39.6627C35.8749 39.4534 35.9463 39.1799 36.1601 39.0599L38.207 37.9111L36.0053 37.018C35.7708 36.9229 35.6677 36.6476 35.7821 36.4218L36.3412 35.3178C36.4504 35.1022 36.7152 35.0179 36.929 35.1307L39.2271 36.3436L39.1236 34.1091C39.1122 33.8626 39.309 33.6565 39.5557 33.6565H40.8556C41.1055 33.6565 41.3034 33.8676 41.2872 34.117L41.1429 36.3436L43.1314 34.7738C43.3323 34.6152 43.6262 34.6647 43.764 34.8804L44.4043 35.8827C44.5383 36.0923 44.4682 36.3714 44.2512 36.493L42.163 37.6623L44.4414 38.6448C44.6745 38.7453 44.7714 39.0239 44.6509 39.2473L44.0597 40.3431C43.9465 40.5529 43.6849 40.6316 43.4748 40.519L41.0683 39.2298Z"
          fill="#F5084A"
        />
        <path
          d="M53.589 39.2298L53.6709 41.3182C53.6806 41.5636 53.4842 41.7677 53.2387 41.7677H51.9824C51.7336 41.7677 51.5361 41.5584 51.5506 41.31L51.6732 39.205L49.7682 40.758C49.565 40.9236 49.2624 40.8719 49.1258 40.6482L48.5235 39.6627C48.3956 39.4534 48.467 39.1799 48.6809 39.0599L50.7277 37.9111L48.5261 37.018C48.2915 36.9229 48.1884 36.6476 48.3028 36.4218L48.8619 35.3178C48.9712 35.1022 49.2359 35.0179 49.4497 35.1307L51.7478 36.3436L51.6444 34.1091C51.633 33.8626 51.8297 33.6565 52.0765 33.6565H53.3763C53.6262 33.6565 53.8242 33.8676 53.808 34.117L53.6637 36.3436L55.6522 34.7738C55.8531 34.6152 56.1469 34.6647 56.2847 34.8804L56.9251 35.8827C57.059 36.0923 56.989 36.3714 56.7719 36.493L54.6838 37.6623L56.9622 38.6448C57.1953 38.7453 57.2921 39.0239 57.1716 39.2473L56.5805 40.3431C56.4673 40.5529 56.2057 40.6316 55.9955 40.519L53.589 39.2298Z"
          fill="#F5084A"
        />
        <path
          d="M66.1093 39.2298L66.1912 41.3182C66.2008 41.5636 66.0045 41.7677 65.759 41.7677H64.5027C64.2539 41.7677 64.0564 41.5584 64.0708 41.31L64.1935 39.205L62.2884 40.758C62.0853 40.9236 61.7827 40.8719 61.646 40.6482L61.0437 39.6627C60.9159 39.4534 60.9873 39.1799 61.2011 39.0599L63.248 37.9111L61.0464 37.018C60.8118 36.9229 60.7087 36.6476 60.8231 36.4218L61.3822 35.3178C61.4914 35.1022 61.7562 35.0179 61.97 35.1307L64.2681 36.3436L64.1646 34.1091C64.1532 33.8626 64.35 33.6565 64.5967 33.6565H65.8966C66.1465 33.6565 66.3444 33.8676 66.3283 34.117L66.1839 36.3436L68.1724 34.7738C68.3733 34.6152 68.6672 34.6647 68.805 34.8804L69.4454 35.8827C69.5793 36.0923 69.5092 36.3714 69.2922 36.493L67.2041 37.6623L69.4825 38.6448C69.7155 38.7453 69.8124 39.0239 69.6919 39.2473L69.1007 40.3431C68.9876 40.5529 68.7259 40.6316 68.5158 40.519L66.1093 39.2298Z"
          fill="#F5084A"
        />
      </g>
      <path
        d="M8.45117 80.3222V39.8251L46.9795 67.9804L85.5078 39.8251V80.3222C85.5078 82.5085 83.7355 84.2809 81.5491 84.2809H12.4098C10.2235 84.2809 8.45117 82.5085 8.45117 80.3222Z"
        fill="#FADAD7"
      />
      <path
        d="M83.9715 42.851L47.8865 69.2211C47.3465 69.6157 46.613 69.6157 46.073 69.2211L9.98803 42.851V80.3218C9.98803 81.6594 11.0724 82.7445 12.41 82.7445H81.5495C82.8871 82.7445 83.9715 81.6594 83.9715 80.3218V42.851ZM87.0447 80.3218C87.0447 83.3567 84.5844 85.8177 81.5495 85.8178H12.41C9.37508 85.8177 6.91479 83.3568 6.91479 80.3218V39.825C6.91479 39.2465 7.23999 38.717 7.75588 38.455C8.27162 38.1932 8.89071 38.2429 9.35778 38.584L46.9794 66.0766L84.6017 38.584C85.0688 38.2429 85.6879 38.1932 86.2036 38.455C86.7195 38.717 87.0447 39.2465 87.0447 39.825V80.3218Z"
        fill="#47093A"
      />
      <path
        d="M44.759 54.6708C46.0995 53.76 47.8603 53.7601 49.2008 54.6708L84.118 83.3365C83.4281 83.9247 82.5343 84.281 81.5566 84.281H12.4032C11.4252 84.281 10.5308 83.925 9.84082 83.3365L44.759 54.6708Z"
        fill="#FADAD7"
      />
      <path
        d="M43.8953 53.3995C45.6988 52.1743 48.0503 52.136 49.888 53.2847L50.0643 53.3995L50.1753 53.4828L85.0929 82.1488C85.4445 82.4375 85.6498 82.8673 85.6541 83.3223C85.6583 83.7772 85.4608 84.2104 85.1146 84.5055C84.1585 85.3207 82.915 85.8177 81.5567 85.8178H12.4029C11.0449 85.8178 9.80028 85.3216 8.84349 84.5055C8.49744 84.2104 8.29981 83.7771 8.30402 83.3223C8.3083 82.8674 8.51437 82.4375 8.866 82.1488L43.7835 53.4828L43.8953 53.3995ZM48.2943 55.9145C47.4939 55.3948 46.4622 55.3951 45.6623 55.916L12.9829 82.7446H80.9752L48.2943 55.9145Z"
        fill="#47093A"
      />
      <defs>
        <filter
          id="greetz-card-shadow"
          x="6.86987"
          y="13.557"
          width="76.4451"
          height="62.3903"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.45" />
          <feGaussianBlur stdDeviation="1.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0117647 0 0 0 0 0.301961 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11352_1301"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11352_1301"
            result="shape"
          />
        </filter>
        <filter
          xmlns="http://www.w3.org/2000/svg"
          id="mail-icon-shadow"
          x="60"
          y="59"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0117647 0 0 0 0 0.301961 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11352_1301"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11352_1301"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
